import { render, staticRenderFns } from "./personalInforForm.vue?vue&type=template&id=048b2f5f"
import script from "./personalInforForm.vue?vue&type=script&lang=js"
export * from "./personalInforForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports